// @ts-ignore
import * as crypto from 'crypto-js';
import { logger } from 'src/services/logger/loggerService';
import { getDomainName } from 'src/services/utils';

export const setJSONValue = (key: CookieKeys, data: any = '') => {
  const _config = Config[key];
  if (_config) {
    document.cookie = `${key}=${data}; expires=${new Date(
      new Date().getTime() + _config.expiryInSeconds * 1000,
    ).toUTCString()}; domain:${_config.domainsToShare};path=/`;
  }
};

export enum CookieKeys {
  'TOKEN_CONTEXT' = 'TOKEN_CONTEXT',
  'KEY_PAIR_ID' = 'CloudFront-Key-Pair-Id',
  'POLICY' = 'CloudFront-Policy',
  'SIGNATURE' = 'CloudFront-Signature',
}

const Config = {
  [CookieKeys.TOKEN_CONTEXT]: {
    expiryInSeconds: 60 * 60 * 24 * 7,
    domainsToShare: 'pw.live',
  },
  [CookieKeys.KEY_PAIR_ID]: {
    expiryInSeconds: 60 * 60 * 6,
    domainsToShare: 'pw.live',
  },
  [CookieKeys.POLICY]: {
    expiryInSeconds: 60 * 60 * 6,
    domainsToShare: 'pw.live',
  },
  [CookieKeys.SIGNATURE]: {
    expiryInSeconds: 60 * 60 * 6,
    domainsToShare: 'pw.live',
  },
};

export function cookieSplitter(cookie: string) {
  let decryptedCookie = '';
  if (!cookie) {
    return '';
  }
  const cookieArr = cookie.split('&');
  for (let i = 0; i < 3; i++) {
    const cookiePart = cookieArr[i].split(/=(.*)/s); // splits from first occurrence of "="
    decryptedCookie += cookiePart[0];
    decryptedCookie += '=' + getDecryptCookie(cookiePart[1]).toString() + '&';
  }
  return decryptedCookie.substr(1, decryptedCookie.length - 2);
}

function getDecryptCookie(cookie: any) {
  const key = crypto.enc.Utf8.parse(KEYS.VIDEO_ENCRYPTION_KEY);
  const iv = crypto.enc.Utf8.parse(KEYS.INITIALISATION_VECTOR);
  const decryptedKey = crypto.AES.decrypt(cookie, key, { iv: iv });
  return decryptedKey.toString(crypto.enc.Utf8);
  // let decipher = crypto.createDecipheriv('aes-256-cbc', KEYS.VIDEO_ENCRYPTION_KEY, KEYS.INITIALISATION_VECTOR);
  // let decrypted = decipher.update(cookie, 'base64', 'utf8');
  // return (decrypted + decipher.final('utf8'));
}

enum KEYS {
  VIDEO_ENCRYPTION_KEY = 'pw3c199c2911cb437a907b1k0907c17n',
  INITIALISATION_VECTOR = '5184781c32kkc4e8',
}
export const getValue = (key: CookieKeys) => {
  const name = key + '=';
  let decodedCookie = document.cookie;
  try {
    decodedCookie = decodeURIComponent(document.cookie);
  } catch (error) {
    logger.debug('Error decoding cookie:', error);
    return ''; // Return an empty string or handle the error as needed
  }
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      const val = c.substring(name.length, c.length);
      if (val) {
        return JSON.parse(val);
      }
      return '';
    }
  }
  return '';
};
export const setValue = (key: CookieKeys, data: any = '') => {
  const _config = Config[key];
  if (_config) {
    document.cookie = `${key}=${JSON.stringify(data)}; expires=${new Date(new Date().getTime() + _config.expiryInSeconds * 1000).toUTCString()}; domain:${_config.domainsToShare}`;
  }
};
export const setPreSignedCookies = (data: string) => {
  if (!data) return;
  const expires = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  Object.entries(data).forEach(([key, value]) => {
    if (typeof value === 'string') {
      setCookie(key, getDecryptCookie(value), expires, 60 * 60 * 24 * 365);
    }
  });
};

export const setCookie = (
  key: string,
  value: string,
  expiry: Date,
  maxAge: number,
  domainsToShare?: string,
) => {
  if (!domainsToShare) {
    domainsToShare = getDomainName();
  }
  document.cookie = `${key}=${value};domain=.${domainsToShare};expires=${expiry};max-age=${maxAge};path=/;`;
};

export const setMediaCDNCookiesFromResponse = (cookieString: string) => {
  document.cookie = `Edge-Cache-Cookie=${cookieString}; domain=.${getDomainName()}; path=/; SameSite=Strict`;
};

export const getMediaCDNCookieExpiry = (cookieString: string) => {
  const decodedCookie = cookieString.split(':');
  for (let i = 0; i < decodedCookie.length; i++) {
    const d = decodedCookie[i];
    if (d.includes('Expires=')) {
      const value = d.split('Expires=')[1];
      return JSON.parse(value) * 1000;
    }
  }
  return 0;
};

export const getTokenCookies = () => {
  try {
    return getValue(CookieKeys.TOKEN_CONTEXT)?.token;
  } catch (error) {
    logger.error('Error getting token from cookies:', error);
    return null;
  }
};

export const getRandomIdCookies = () => {
  try {
    return getValue(CookieKeys.TOKEN_CONTEXT)?.randomId;
  } catch (error) {
    logger.error('Error getting randomId from cookies:', error);
    return null;
  }
};

export const getTokenExpireIn = () => {
  try {
    const tokenContext = getValue(CookieKeys.TOKEN_CONTEXT);
    if (tokenContext && tokenContext.expires_in) {
      return tokenContext.expires_in;
    }
    return null;
  } catch (error) {
    logger.error('Error reading expire_in from TOKEN_CONTEXT cookie:', error);
    return null;
  }
};

logger.log('getTokenExpireIn getTokenExpireIn', getTokenExpireIn());

export const isTokenExpired = () => {
  try {
    const tokenContext = getValue(CookieKeys.TOKEN_CONTEXT);
    logger.log('Token Context before:', tokenContext);
    if (!tokenContext || !tokenContext.expires_in) {
      // If no token context or expires_in, consider it expired
      return true;
    }

    const expiryTime = new Date(tokenContext.expires_in).getTime();
    const currentTime = new Date().getTime();
    logger.log(
      'Token Context After:',
      tokenContext,
      expiryTime,
      currentTime,
      currentTime > expiryTime,
    );
    // Return true if current time is greater than expiry time
    return currentTime > expiryTime;
  } catch (error) {
    logger.error('Error checking if token is expired:', error);
    // In case of error, consider token as expired for safety
    return true;
  }
};

export const CookieService = {
  setValue,
  getValue,
  setMediaCDNCookiesFromResponse,
  setPreSignedCookies,
  getMediaCDNCookieExpiry,
  getTokenExpireIn,
  isTokenExpired,
  getTokenCookies,
  getRandomIdCookies,
};
